import Trans from 'next-translate/Trans'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import SingleAssign from './SingleAssign'

const AssignTransactions = ({ transactions }) => {
  const { transaction } = useTransaction()
  return transactions.length === 0
    ? (
      <p>
        <Trans i18nKey={transaction?.matchedLoad
          ? 'transaction:noTrucksToAssign' : 'transaction:noLoadsToAssign'}
        />
      </p>
    )
    : (
      <table className="tennders-table-zebra">
        <tbody>
          {
            transactions?.map((transaction) => (
              <SingleAssign key={transaction.id} toMatch={transaction} />
            ))
          }
        </tbody>
      </table>
    )
}

export default AssignTransactions
